<template>
  <el-col class="c-app-board-item" v-perm="innerPerms" v-bind="innerColAttrs">
    <div class="board__body">
      <cmpt v-if="innerItemConfig.cmpt" :config="innerItemConfig.cmpt" :context-data="itemState" />
      <component
        v-else-if="innerItemConfig.componentType"
        :is="innerItemConfig.componentType"
        v-bind="innerItemConfig"
        :model="itemState.model"
        :context-data="itemState"
      />
    </div>
  </el-col>
</template>

<script setup lang="ts">
import { ref, computed, reactive, inject, onMounted, useHostAppInstance, useAttrs } from '@zto/zpage'
import { appUtil } from '@zto/zpage-ui-element'

import { APP_BOARD_STATE_KEY } from './consts'
import { normalizeBoardItemConfig, getPayloadData } from './util'

import type { AppBoardItemConfig } from './types'

const props = withDefaults(
  defineProps<{
    span?: number
    height?: string
    config?: AppBoardItemConfig
  }>(),
  {
    span: 24
  }
)

const app = useHostAppInstance()

const boardState = inject(APP_BOARD_STATE_KEY)

const itemState = reactive({
  model: {},
  board: boardState,
  config: props.config
})

const innerContext = app.useContext(itemState)

const innerColAttrs = computed(() => {
  return {
    span: props.config?.span || props.span || 24,
    style: { height: innerItemConfig.value?.height || props.height, ...innerItemConfig.value?.style }
  }
})

// 配置
const innerItemConfig = computed(() => {
  if (!props.config) return {}

  const config = normalizeBoardItemConfig(props.config, innerContext)

  return config
})

// 权限配置
const innerPerms = computed(() => {
  const perms = appUtil.getCmptPermData(innerItemConfig)
  return perms
})

onMounted(async () => {
  const config = innerItemConfig.value

  itemState.model = await fetchPayload()

  if (config.onLoad) {
    await config.onLoad(innerContext)
  }
})

async function fetchPayload() {
  const config = innerItemConfig.value

  let payload = {}

  if (config.payload) {
    payload = await getPayloadData(config.payload, innerContext)
    return payload
  }

  const api = config.api

  if (api) {
    const apiParams = config.apiParams

    const params = await getPayloadData(config.apiParams, innerContext)

    payload = await app.request({ action: config.api, params })
  }

  return payload
}
</script>

<style lang="scss" scoped>
.c-app-board-item {
  margin-bottom: 10px;
}
</style>
